import i18next from 'i18next';

i18next.addResources('es', 'home', {
  recommendContent: 'Contenido destacado',
  featuredEvents: 'Eventos destacados',
  seeAll: 'Ver todos',
  mainTitle: 'Innovamos en infraestructura de integración'
});
